<template>
    <div class="auth authBgColor">
        <div class="container container--center">
            <div class="auth__containerAdaptive auth__containerAdaptive--auto">
                <div class="auth__left" id="col-auth-left">
                    <div class="auth__imgCompany">
                        <img :src="domain_logo ? domain_logo : '/common/images/logo_aira_sm.png'" alt="">
                    </div>
                    <div class="auth__left__content">
                        <div class="row margin-none">
                            <div class="col s12 pad-none">
                                <a class="auth__back margin-bot" :href="email_applicant?`/?email=${email_applicant}`:'/'"><i class="fas fa-chevron-left authColor"></i> <span class="underline authColor">{{$t(`auth.landing_page_applicant.register_form.actions.return`)}}</span></a>
                                <h1 class="auth__title authColor margin-bot-mid">{{$t(`auth.landing_page_applicant.register_form.texts.title`)}}</h1>
                                <div class="margin-bot">{{$t(`auth.landing_page_applicant.register_form.texts.subtitle`)}}</div>
                                <div v-if="alert_type" :class="`alert${alert_type} alert${alert_type}--inline margin-bot-mid`" v-html="alert_message">
                                </div>
                                <form @submit.prevent="registerApplicant">
                                    <div class="row margin-bot-none">
                                        <div class="col s12 input-field">
                                            <input 
                                                id="email" type="email" name="email" class="auth--input" 
                                                :class="{ invalid: $v.email.$error }"
                                                :placeholder="$t('auth.landing_page_applicant.register_form.placeholders.email')" 
                                                v-model="email"
                                            >
                                            <label for="email" class="base-fontsize active">
                                                {{$t(`auth.landing_page_applicant.register_form.labels.email`)}}
                                            </label>
                                            <validationErrors
                                                :validation_field="$v.email"
                                                name="email"
                                                lang_prefix="validation"
                                                class="validation-error--marginNone"
                                            ></validationErrors>
                                        </div>
                                    </div>
                                    <div class="row margin-bot-none">
                                        <div class="col s12 input-field">
                                            <div class="input-field-password">
                                                <input 
                                                    id="password101" type="password" name="password" class="auth--input"
                                                    :class="{ invalid: $v.password.$error }" 
                                                    :placeholder="$t('auth.landing_page_applicant.register_form.placeholders.password')" 
                                                    v-model="password"
                                                >
                                                <i id="icon101" onclick="showPassword(101)" class="cursor-pointer fas fa-eye-slash"></i>
                                            </div>
                                            <label for="password101" class="base-fontsize active">
                                                {{$t(`auth.landing_page_applicant.register_form.labels.password`)}}
                                            </label>
                                            <validationErrors
                                                :validation_field="$v.password"
                                                name="password"
                                                lang_prefix="validation"
                                                class="validation-error--marginNone"
                                            ></validationErrors>
                                        </div>
                                    </div>
                                    <div class="row margin-bot-none">
                                        <div class="col s12 input-field">
                                            <div class="input-field-password">
                                                <input 
                                                    id="password102" type="password" name="password_confirmation" class="auth--input" 
                                                    :placeholder="$t('auth.landing_page_applicant.register_form.placeholders.password')" 
                                                    v-model="password_confirmation"
                                                >
                                                <i id="icon102" onclick="showPassword(102)" class="cursor-pointer fas fa-eye-slash"></i>
                                            </div>
                                            <label for="password102" class="base-fontsize active">
                                                {{$t(`auth.landing_page_applicant.register_form.labels.repeat_password`)}}
                                            </label>
                                        </div>
                                    </div>
                                    <div class="row margin-bot-none">
                                        <div class="col s12">
                                            <p class="auth__checkbox margin-none">
                                                <label>
                                                    <input type="checkbox" v-model="terms" />
                                                    <span>
                                                        <a :href="terms_url" target="_blank" class="authColor">{{$t(`auth.landing_page_applicant.register_form.actions.accept_terms`)}}</a>
                                                    </span>
                                                </label>
                                                <validationErrors
                                                    :validation_field="$v.terms"
                                                    name="terms"
                                                    lang_prefix="validation"
                                                    class="validation-error--marginNone"
                                                ></validationErrors>
                                            </p>
                                        </div>
                                    </div>
                                    <div class="margin-top">
                                        <button type="submit" class="btnPrimary fullwidth" :disabled="applicantRegistering">{{$t(`auth.landing_page_applicant.register_form.actions.submit${applicantRegistering?'_active':''}`)}}</button>
                                    </div>
                                </form>
                                <div class="auth__separator margin-top-mid">
                                    <hr class="auth__separator__line">
                                    <span class="auth__separator__text">o</span>
                                    <hr class="auth__separator__line">
                                </div>
                                <social-login :social_login="social_login"></social-login>
                                <template v-for="(provider_config, provider) in applicant_login_providers">
                                    <div class="margin-top">
                                        <template v-if="provider_config.type == 'gigya'">
                                            <a
                                                href="#"
                                                :class="`btnSecondary btnSecondary--auth fullwidth ${provider}-btn`"
                                                @click="showGigyaScreen(provider_config.screen_set, provider_config.start_screen)"
                                            >
                                                {{ provider_config.name ? provider_config.name : provider }}
                                            </a>
                                        </template>
                                        <template v-else-if="provider_config.type == 'redirect'">
                                            <a
                                                :href="provider_config.href? provider_config.href : `/login/auth/${provider}`"
                                                :class="`btnSecondary btnSecondary--auth fullwidth ${provider}-btn`"
                                            >
                                                {{ provider_config.name ? provider_config.name : provider }}
                                            </a>
                                        </template>
                                        <template v-else>
                                            <a
                                                :href="provider_config.auth_url? provider_config.auth_url : `/login/auth/${provider}`"
                                                :class="`btnSecondary btnSecondary--auth fullwidth ${provider}-btn`"
                                            >
                                                {{ provider_config.name ? provider_config.name : provider }}
                                            </a>
                                        </template>
                                    </div>
                                </template>
                                <template v-if="Object.keys(applicant_login_footer_content).length > 0">
                                    <div class="margin-top">
                                        <div class="small-fontsize center">
                                            <p class="margin-none" v-html="getFeatureByBaseLocale(applicant_login_footer_content, '')"></p>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="auth__right" id="col-auth-right">
                    <img class="auth__right__img" :src="getFeatureByBaseLocale(applicant_login_image, `/common/images/login/aira/applicant/background_login_${base_locale}.png`)" alt="">
                    <div class="auth__right__info">
                        <div class="row margin-none pad-mid">
                            <div class="col s12">
                                <p v-for="(login_message, idx) in login_messages" :key="idx">{{ login_message }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import * as M from "materialize-css";
import Loading from "vue-loading-overlay";
import { validationMixin } from "vuelidate";
import validationErrors from "../ValidationErrors.vue";
import {
    required,
    email,
    helpers
} from "vuelidate/lib/validators";
import { registerApplicant } from "../../api/auth";
import SocialLogin from "./SocialLogin.vue";

const requiredWithAttribute = (attribute) => helpers.withParams({ type: 'required', attribute: attribute }, required);

const emailWithAttribute = (attribute) => helpers.withParams({ type: "email", attribute: attribute }, email);

const serverFailed = (errors) => helpers.withParams(
    { type: 'serverFailed', custom_message: ((errors.length > 0) ? errors[0] : '') },
    (value) => (errors.length === 0)
);

export default {
    name: "ApplicantRegister",
    mixins: [ validationMixin ],
    components: {
        validationErrors,
        SocialLogin
    },
    props: {
        alert_type: {
            type: String
        }, 
        alert_message: {
            type: String
        }, 
        offer_id: {
            type: Number
        }, 
        source: {
            type: String
        }, 
        email_applicant: {
            type: String
        }, 
        domain_logo: {
            type: String
        },
        terms_url: {
            type: String
        },
        social_login: {
            type: Object,
            default: () => ({})
        },
        applicant_login_image: {
            type: Object,
            default: () => ({})
        },
        login_messages: {
            type: Object,
            default: () => ({})
        },
        applicant_login_providers: {
            type: Object,
            default: () => ({})
        },
        applicant_login_footer_content: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            applicantRegistering: false,
            base_locale: 'es',
            email: '',
            password: '',
            password_confirmation: '',
            terms: false,
            serverErrors: {
                email: [],
                password: [],
                terms: []
            }
        }
    },
    validations() {
        let email_attribute = this.$i18n.t('auth.landing_page_applicant.register_form.labels.email').toLowerCase();
        let password_attribute = this.$i18n.t('auth.landing_page_applicant.register_form.labels.password').toLowerCase();

        let validations = {
            email: {
                required: requiredWithAttribute(email_attribute),
                email: emailWithAttribute(email_attribute),
                serverFailed: serverFailed(this.serverErrors.email)
            },
            password: {
                required: requiredWithAttribute(password_attribute),
                serverFailed: serverFailed(this.serverErrors.password)
            },
            terms: {
                serverFailed: serverFailed(this.serverErrors.terms)
            },
        };

        return validations;
    },
    mounted: function () {
        this.base_locale = this.$i18n.locale.slice(0,2);
        this.email = this.email_applicant;
        setUserTypeInWidget('Candidato');
    },
    methods: {
        getFeatureByBaseLocale(feature_array, default_value) {
            if(feature_array[this.base_locale]) {
                return feature_array[this.base_locale];
            }
            if(feature_array['default']) {
                return feature_array['default'];
            }
            return default_value;
        },
        showGigyaScreen(screen_set, start_screen) {
            gigya.accounts.showScreenSet({
                screenSet: (screen_set ? screen_set : 'Default-RegistrationLogin'),
                startScreen: (start_screen ? start_screen : 'gigya-login-screen')
            });
        },
        async registerApplicant() {
            const vm = this;
            vm.serverErrors = { email: [], password: [], terms: [] };
            vm.$v.$touch();
            if (!vm.$v.$invalid) {
                vm.applicantRegistering = true;
                await registerApplicant({
                    offer_id: this.offer_id,
                    source: this.source,
                    email: this.email,
                    password: this.password,
                    password_confirmation: this.password_confirmation,
                    terms: this.terms,
                }).then(response => {
                    window.location = response.data.redirectTo;
                })
                .catch(error => {
                    Object.keys(error.data).forEach(key => {
                        vm.serverErrors[key].push(error.data[key][0]);
                    });
                });
                vm.applicantRegistering = false;
            }
        },
    }
}
</script>